// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/Users/maying/work/store-web/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from 'components/Loading.js';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index.js'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/404",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.js'), loading: LoadingComponent})
      },
      {
        "path": "/aiNotice/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiNotice__auditing' */'@/pages/aiNotice/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/aiNotice/callWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiNotice__callWord' */'@/pages/aiNotice/callWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/aiNotice/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiNotice__deleted' */'@/pages/aiNotice/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/aiNotice/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiNotice__edit' */'@/pages/aiNotice/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/aiNotice/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiNotice__pending' */'@/pages/aiNotice/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/aiNotice/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiNotice__release' */'@/pages/aiNotice/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/aiNotice/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiNotice__sendCls' */'@/pages/aiNotice/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/autoComment/ai",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__autoComment__ai' */'@/pages/autoComment/ai.js'), loading: LoadingComponent})
      },
      {
        "path": "/autoComment/article",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__autoComment__article' */'@/pages/autoComment/article.js'), loading: LoadingComponent})
      },
      {
        "path": "/autoComment/callWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__autoComment__callWord' */'@/pages/autoComment/callWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/beijiaosuo/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__beijiaosuo__auditing' */'@/pages/beijiaosuo/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/beijiaosuo/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__beijiaosuo__deleted' */'@/pages/beijiaosuo/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/beijiaosuo/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__beijiaosuo__edit' */'@/pages/beijiaosuo/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/beijiaosuo/highlightWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__beijiaosuo__highlightWord' */'@/pages/beijiaosuo/highlightWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/beijiaosuo/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__beijiaosuo__pending' */'@/pages/beijiaosuo/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/beijiaosuo/releaseTelegraph",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__beijiaosuo__releaseTelegraph' */'@/pages/beijiaosuo/releaseTelegraph.js'), loading: LoadingComponent})
      },
      {
        "path": "/beijiaosuo/releaseTopic",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__beijiaosuo__releaseTopic' */'@/pages/beijiaosuo/releaseTopic.js'), loading: LoadingComponent})
      },
      {
        "path": "/bond/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bond__auditing' */'@/pages/bond/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/bond/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bond__deleted' */'@/pages/bond/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/bond/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bond__edit' */'@/pages/bond/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/bond/highlightWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bond__highlightWord' */'@/pages/bond/highlightWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/bond/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bond__pending' */'@/pages/bond/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/bond/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bond__release' */'@/pages/bond/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/bond/spare",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bond__spare' */'@/pages/bond/spare.js'), loading: LoadingComponent})
      },
      {
        "path": "/bulkCargo/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bulkCargo__deleted' */'@/pages/bulkCargo/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/bulkCargo/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bulkCargo__release' */'@/pages/bulkCargo/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/conceptDynamic/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__conceptDynamic__deleted' */'@/pages/conceptDynamic/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/conceptDynamic/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__conceptDynamic__release' */'@/pages/conceptDynamic/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/externalContentAudit/auditEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalContentAudit__auditEdit' */'@/pages/externalContentAudit/auditEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/externalContentAudit/clscms",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalContentAudit__clscms' */'@/pages/externalContentAudit/clscms.js'), loading: LoadingComponent})
      },
      {
        "path": "/externalContentAudit/passed",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalContentAudit__passed' */'@/pages/externalContentAudit/passed.js'), loading: LoadingComponent})
      },
      {
        "path": "/externalContentAudit/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalContentAudit__pending' */'@/pages/externalContentAudit/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/externalContentAudit/recycle",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalContentAudit__recycle' */'@/pages/externalContentAudit/recycle.js'), loading: LoadingComponent})
      },
      {
        "path": "/finance/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance__auditing' */'@/pages/finance/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/finance/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance__deleted' */'@/pages/finance/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/finance/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance__edit' */'@/pages/finance/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/finance/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance__pending' */'@/pages/finance/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/finance/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance__release' */'@/pages/finance/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/financeDynamic/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__financeDynamic__deleted' */'@/pages/financeDynamic/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/financeDynamic/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__financeDynamic__release' */'@/pages/financeDynamic/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/fundplate/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fundplate__deleted' */'@/pages/fundplate/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/fundplate/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fundplate__release' */'@/pages/fundplate/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/fundstock/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fundstock__deleted' */'@/pages/fundstock/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/fundstock/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fundstock__release' */'@/pages/fundstock/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggu/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggu__auditing' */'@/pages/ganggu/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggu/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggu__deleted' */'@/pages/ganggu/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggu/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggu__edit' */'@/pages/ganggu/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggu/highlightWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggu__highlightWord' */'@/pages/ganggu/highlightWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggu/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggu__pending' */'@/pages/ganggu/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggu/releaseTelegraph",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggu__releaseTelegraph' */'@/pages/ganggu/releaseTelegraph.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggu/releaseTopic",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggu__releaseTopic' */'@/pages/ganggu/releaseTopic.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggureport/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggureport__auditing' */'@/pages/ganggureport/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggureport/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggureport__deleted' */'@/pages/ganggureport/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggureport/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggureport__edit' */'@/pages/ganggureport/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggureport/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggureport__pending' */'@/pages/ganggureport/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggureport/releaseTelegraph",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggureport__releaseTelegraph' */'@/pages/ganggureport/releaseTelegraph.js'), loading: LoadingComponent})
      },
      {
        "path": "/ganggureport/releaseTopic",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ganggureport__releaseTopic' */'@/pages/ganggureport/releaseTopic.js'), loading: LoadingComponent})
      },
      {
        "path": "/gpt/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gpt__auditing' */'@/pages/gpt/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/gpt/callWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gpt__callWord' */'@/pages/gpt/callWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/gpt/callWordList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gpt__callWordList' */'@/pages/gpt/callWordList.js'), loading: LoadingComponent})
      },
      {
        "path": "/gpt/delete",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gpt__delete' */'@/pages/gpt/delete.js'), loading: LoadingComponent})
      },
      {
        "path": "/gpt/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gpt__pending' */'@/pages/gpt/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/gpt/publish",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gpt__publish' */'@/pages/gpt/publish.js'), loading: LoadingComponent})
      },
      {
        "path": "/hotlist/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__hotlist__deleted' */'@/pages/hotlist/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/hotlist/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__hotlist__release' */'@/pages/hotlist/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/hushenStock/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__hushenStock__deleted' */'@/pages/hushenStock/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/hushenStock/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__hushenStock__release' */'@/pages/hushenStock/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__auditing' */'@/pages/interact/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/blockWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__blockWord' */'@/pages/interact/blockWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/callWordList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__callWordList' */'@/pages/interact/callWordList.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/callword",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__callword' */'@/pages/interact/callword.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__deleted' */'@/pages/interact/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/filter",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__filter' */'@/pages/interact/filter.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/highlightWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__highlightWord' */'@/pages/interact/highlightWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__pending' */'@/pages/interact/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__release' */'@/pages/interact/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__sendCls' */'@/pages/interact/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/interact/trialEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__interact__trialEdit' */'@/pages/interact/trialEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/jieyue/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__jieyue__auditing' */'@/pages/jieyue/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/jieyue/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__jieyue__deleted' */'@/pages/jieyue/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/jieyue/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__jieyue__edit' */'@/pages/jieyue/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/jieyue/highlightWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__jieyue__highlightWord' */'@/pages/jieyue/highlightWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/jieyue/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__jieyue__pending' */'@/pages/jieyue/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/jieyue/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__jieyue__release' */'@/pages/jieyue/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/jieyue/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__jieyue__sendCls' */'@/pages/jieyue/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/limitup/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__limitup__deleted' */'@/pages/limitup/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/limitup/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__limitup__release' */'@/pages/limitup/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/login",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__login__index' */'@/pages/login/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/longhubang/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__longhubang__deleted' */'@/pages/longhubang/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/longhubang/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__longhubang__release' */'@/pages/longhubang/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/meigu/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__meigu__auditing' */'@/pages/meigu/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/meigu/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__meigu__deleted' */'@/pages/meigu/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/meigu/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__meigu__edit' */'@/pages/meigu/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/meigu/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__meigu__pending' */'@/pages/meigu/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/meigu/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__meigu__release' */'@/pages/meigu/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/nonStandard/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__nonStandard__auditing' */'@/pages/nonStandard/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/nonStandard/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__nonStandard__deleted' */'@/pages/nonStandard/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/nonStandard/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__nonStandard__pending' */'@/pages/nonStandard/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/nonStandard/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__nonStandard__release' */'@/pages/nonStandard/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/nonStandard/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__nonStandard__sendCls' */'@/pages/nonStandard/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/nonStandard/trialEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__nonStandard__trialEdit' */'@/pages/nonStandard/trialEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/notice/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notice__auditing' */'@/pages/notice/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/notice/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notice__deleted' */'@/pages/notice/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/notice/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notice__pending' */'@/pages/notice/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/notice/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notice__release' */'@/pages/notice/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/notice/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notice__sendCls' */'@/pages/notice/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/notice/trialEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notice__trialEdit' */'@/pages/notice/trialEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/organizationEdit/organizationEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organizationEdit__organizationEdit' */'@/pages/organizationEdit/organizationEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/otherDispense/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__otherDispense__auditing' */'@/pages/otherDispense/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/otherDispense/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__otherDispense__deleted' */'@/pages/otherDispense/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/otherDispense/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__otherDispense__pending' */'@/pages/otherDispense/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/otherDispense/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__otherDispense__release' */'@/pages/otherDispense/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/otherDispense/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__otherDispense__sendCls' */'@/pages/otherDispense/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/otherDispense/trialEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__otherDispense__trialEdit' */'@/pages/otherDispense/trialEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotationLive/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotationLive__auditing' */'@/pages/quotationLive/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotationLive/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotationLive__deleted' */'@/pages/quotationLive/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotationLive/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotationLive__pending' */'@/pages/quotationLive/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotationLive/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotationLive__release' */'@/pages/quotationLive/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotationLive/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotationLive__sendCls' */'@/pages/quotationLive/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotationLive/trialEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotationLive__trialEdit' */'@/pages/quotationLive/trialEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotes/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotes__deleted' */'@/pages/quotes/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/quotes/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__quotes__release' */'@/pages/quotes/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/report/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__report__auditing' */'@/pages/report/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/report/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__report__deleted' */'@/pages/report/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/report/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__report__edit' */'@/pages/report/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/report/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__report__pending' */'@/pages/report/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/report/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__report__release' */'@/pages/report/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/rewrite/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rewrite__auditing' */'@/pages/rewrite/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/rewrite/deleted",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rewrite__deleted' */'@/pages/rewrite/deleted.js'), loading: LoadingComponent})
      },
      {
        "path": "/rewrite/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rewrite__pending' */'@/pages/rewrite/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/rewrite/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rewrite__release' */'@/pages/rewrite/release.js'), loading: LoadingComponent})
      },
      {
        "path": "/rewrite/sendCls",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rewrite__sendCls' */'@/pages/rewrite/sendCls.js'), loading: LoadingComponent})
      },
      {
        "path": "/rewrite/trialEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rewrite__trialEdit' */'@/pages/rewrite/trialEdit.js'), loading: LoadingComponent})
      },
      {
        "path": "/scienceFinance/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scienceFinance__auditing' */'@/pages/scienceFinance/auditing.js'), loading: LoadingComponent})
      },
      {
        "path": "/scienceFinance/callWord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scienceFinance__callWord' */'@/pages/scienceFinance/callWord.js'), loading: LoadingComponent})
      },
      {
        "path": "/scienceFinance/callWordList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scienceFinance__callWordList' */'@/pages/scienceFinance/callWordList.js'), loading: LoadingComponent})
      },
      {
        "path": "/scienceFinance/delete",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scienceFinance__delete' */'@/pages/scienceFinance/delete.js'), loading: LoadingComponent})
      },
      {
        "path": "/scienceFinance/pending",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scienceFinance__pending' */'@/pages/scienceFinance/pending.js'), loading: LoadingComponent})
      },
      {
        "path": "/scienceFinance/publish",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scienceFinance__publish' */'@/pages/scienceFinance/publish.js'), loading: LoadingComponent})
      },
      {
        "path": "/source/approve",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__approve__index' */'@/pages/source/approve/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/source/articleList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__articleList__index' */'@/pages/source/articleList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/source/auditing",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__auditing' */'@/pages/source/auditing.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/source/backup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__backup' */'@/pages/source/backup.js'), loading: LoadingComponent})
      },
      {
        "path": "/source/filter",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__filter' */'@/pages/source/filter.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/source/release",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__release' */'@/pages/source/release.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/source/remove",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__remove' */'@/pages/source/remove.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/source/review",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__source__review' */'@/pages/source/review.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/system/block",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__block' */'@/pages/system/block.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/classification",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__classification' */'@/pages/system/classification.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/customerAuthority",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__customerAuthority' */'@/pages/system/customerAuthority.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/importSource",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__importSource' */'@/pages/system/importSource.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/keywords",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__keywords' */'@/pages/system/keywords.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/system/kpiList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__kpiList' */'@/pages/system/kpiList.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/notOriginal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__notOriginal' */'@/pages/system/notOriginal.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/sensitive",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__sensitive' */'@/pages/system/sensitive.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/sourceTagIds",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__sourceTagIds' */'@/pages/system/sourceTagIds.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/tags",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__tags' */'@/pages/system/tags.js'), loading: LoadingComponent})
      },
      {
        "path": "/system/users",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__users' */'@/pages/system/users.js'), loading: LoadingComponent})
      },
      {
        "path": "/voice/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__voice__edit' */'@/pages/voice/edit.js'), loading: LoadingComponent})
      },
      {
        "path": "/voice/fm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__voice__fm' */'@/pages/voice/fm.js'), loading: LoadingComponent})
      },
      {
        "path": "/voice/list",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__voice__list' */'@/pages/voice/list.js'), loading: LoadingComponent})
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.js'), loading: LoadingComponent})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
